import _taggedTemplateLiteral from "D:\\KODLAR\\ANADOLUNET\\anadoluegitimakademisi\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import React, { useState } from "react";
import styled from "styled-components";
import posed from "react-pose";
import PropTypes from "prop-types";
const ToggleWrapper = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  cursor: pointer;\n  display: flex;\n  height: ", "px;\n  position: relative;\n  width: ", "px;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-around;\n"])), props => props.size / 2, props => props.size / 2);
const Line = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  height: ", "px;\n  width: ", "px;\n  border: white;\n  border-radius: ", "px;\n  background-color: ", ";\n"])), props => props.size * 0.05, props => props.size * 0.5, props => props.size * 0.05, props => props.color);
const Line1 = posed(Line)({
  open: {
    y: props => props.size / 6,
    rotate: 45
  },
  closed: {
    y: 0,
    rotate: 0
  }
});
const Line2 = posed(Line)({
  open: {
    rotate: 0,
    width: 0
  },
  closed: {
    width: props => props.size * 0.5,
    rotate: 0
  }
});
const Line3 = posed(Line)({
  open: {
    y: props => -props.size / 6,
    rotate: -45
  },
  closed: {
    y: 0,
    rotate: 0
  }
});

const MenuToggle = _ref => {
  let {
    size,
    color
  } = _ref;
  const [open, setOpen] = useState(false);
  return /*#__PURE__*/React.createElement(ToggleWrapper, {
    onClick: () => setOpen(true),
    size: size
  }, /*#__PURE__*/React.createElement(Line1, {
    pose: open ? "open" : "closed",
    size: size,
    color: color
  }), /*#__PURE__*/React.createElement(Line2, {
    pose: open ? "open" : "closed",
    size: size,
    color: color
  }), /*#__PURE__*/React.createElement(Line3, {
    pose: open ? "open" : "closed",
    size: size,
    color: color
  }));
};

MenuToggle.defaultProps = {
  size: 60,
  color: "white"
};
MenuToggle.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string
};
export default MenuToggle;